// extracted by mini-css-extract-plugin
export default {"container":"orders_container__CGcsX","order_container":"orders_order_container__5H6of"};